import styled from "styled-components";
import { primaryColor } from "../../../../config/constants";

export const EditButton = styled.button`
  padding: 0 10px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: none;
  border-left: 2px #e6e6e6 solid;
  cursor: pointer;
  position: absolute;
  right: 40px;
`;
export const EditPrescriptionImg = styled.img`
  width: 20px;
  height: 20px;
`;
export const EditPrescriptionText = styled.p`
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
  color: ${primaryColor};
  @media (max-width: 910px) {
    display: none;
  }
`;
